import { useAppDispatch } from '~/hooks/useAppDispatch';
import { trackCardApplicationActions } from '~/store/actions/analyticsActions';
import { patchCardApplication } from '~/store/actions/cardApplicationActions';

const useSubmit = () => {
  const dispatch = useAppDispatch();

  const onSubmit = () => {
    dispatch(
      trackCardApplicationActions({
        actionName: 'submit_button_pressed',
      })
    );
    dispatch(patchCardApplication({ finalized: true }));
  };

  return onSubmit;
};

export default useSubmit;
